import React, { useEffect } from 'react';
import type { FC } from 'react';
import { Alert, Badge, Box, Spinner, Text } from '@wix/cli-ui-kit';
import { isType, match } from 'variant';
import type { CloudProvider } from '@wix/backend-as-a-service-client';
import type { ProjectData } from '../hooks/create-project.js';
import { useCreateProject } from '../hooks/create-project.js';

export const CreateProject: FC<{
  businessId: string;
  businessName: string;
  cloudProviders?: CloudProvider[];
  onSubmit: (data: ProjectData) => void;
}> = ({ onSubmit, businessName, businessId, cloudProviders }) => {
  const { status, execute } = useCreateProject(businessId);

  useEffect(() => {
    if (isType(status, 'Success')) {
      onSubmit(status.result);
    }
  }, [status, onSubmit]);

  useEffect(() => {
    if (businessName) {
      void execute({ businessName, cloudProviders });
    }
  }, [businessName, cloudProviders, execute]);

  return (
    <>
      {match(status, {
        Error: () => null,
        Loading: () => (
          <Box marginBottom={1}>
            <Spinner text="Creating your project..." />
          </Box>
        ),
        Success: () => (
          <Box marginLeft={-2} marginBottom={1}>
            <Alert type="success">
              <Badge skin="success">Success</Badge>{' '}
              <Text>Project created.</Text>
            </Alert>
          </Box>
        ),
        NotRequested: () => null,
      })}
    </>
  );
};
